export default "__VITE_ASSET__3e5586ad__"